import { Box } from '@mui/material';
import { CheckboxOption, FormCheckbox, FormRadioGroup } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';
import { FilterPaymentUserStateFormContext } from './payment-user-state.types';

export const FilterPaymentUserState = () => {
  const { watch, control } = useFormContext<FilterPaymentUserStateFormContext>();
  const { allowStateFilter: isStateFilterEnabled } = watch();
  const stateFilterOptions = useMemo(() => options, []);
  return (
    <Box>
      <FormCheckbox
        name="allowStateFilter"
        label="Status"
        control={control}
        isHeaderCheckbox={true}
      />
      {isStateFilterEnabled ? (
        <FormRadioGroup items={stateFilterOptions} name="state" control={control} />
      ) : null}
    </Box>
  );
};

const options: CheckboxOption[] = [
  {
    value: 'onboarded',
    label: 'Onboarding voltooid',
  },
  {
    value: 'blocked',
    label: 'Geblokkeerd',
  },
];
